import React, { useCallback } from 'react';
import { ConnectedDialog } from '../ConnectedDialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { IConfirmationDialogProps } from './types';

export const ConfirmationDialog = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(dialogSelectors.selectDialogProps, 'confirmation') as IConfirmationDialogProps;

  const onClose = useCallback(() => {
    dispatch(closeDialog('confirmation'));
  }, [dispatch]);

  return (
    <div style={props && props.styles ? props.styles : {}}>
      <ConnectedDialog dialogKey="confirmation">
        <div className="popup delete_popup isVisible">
          <div className="panel">
            <div className="panel-header small-header flex jcsb">
              <h3>{props && props.title ? props.title : 'Confirmation'}</h3>
              <span className="close-popup close" onClick={onClose}>
                <i className="icon-close"></i>
              </span>
            </div>
            <div className="panel-body">
              <h2 className="mb-4 mt-1 text-center">{props && props.message ? props.message : 'Are you sure?'}</h2>
              <div className="flex aic jcc">
                <button className="btn btn-border white-bg close mr-1" style={{ cursor: 'pointer' }} onClick={onClose}>
                  {props && props.cancelButton ? props.cancelButton : 'No'}
                </button>
                <button className="btn red-bg white" onClick={props && props.onConfirm}>
                  {props && props.confirmButton ? props.confirmButton : 'Yes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ConnectedDialog>
    </div>
  );
};
